export default __webpack_public_path__ + "static/media/AudiWhite.e7fb3c87.png";